
export class Task {
    taskNo: string = '';
    projNo: string = '';
    taskName: string = '';
    expType: string = '';
    startDt: Date | undefined;
    endDt: Date | undefined;

    static fromJSONArray(tasks: Array<any>): Task[] {
        return tasks.map(task => new Task(task));
    }

    constructor(task?: any) {
        if (!!task) {
            this.taskNo = task['taskNo'];
            this.projNo = task['projNo'];
            this.taskName = task['taskName'];
            this.expType = task['expType'];
            this.startDt = task['startDt'];
            this.endDt = task['endDt'];
        }
    }
}

